import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrash } from "@fortawesome/free-solid-svg-icons";
import { Measurement, Select } from "../../../../form-inputs/inputs";
import { Typeahead, AsyncTypeahead } from "../../../../form-inputs/typeahead";

import { noteMarkList } from "../../nutritionpanel/lib/constants";

const minMaxList = [
    { value: "min", text: "Min." },
    { value: "max", text: "Max." },
    { value: "minimum", text: "Minimum" },
    { value: "maximum", text: "Maximum" },
];

const AnalysisItem = (props) => {
    const updateMeasurement = (name, value, index) => {
        const measurements = props.data.measurements.map((m, i) => {
            if (i === index) {
                return { ...value };
            }

            return { ...m };
        });

        props.updateField({
            ...props.data,
            measurements,
        });
    };

    const updateField = (key, value) => {
        props.updateField({
            ...props.data,
            [key]: value,
        });
    };

    const removeItem = () => {
        props.removeItem(props.data.key);
    };
    const { measurements, minMax, noteMark, nutrient } = props.data;
    const measurementItems = measurements.map((measurement, index) => {
        return (
            <Measurement
                key={`gaMeasurement_${index}`}
                name="measurement"
                defaultValue={measurement}
                updateOnChange={(name, value) => {
                    updateMeasurement(name, value, index);
                }}
            />
        );
    });

    return (
        <div className="analysis-item" style={props.style}>
            <Typeahead name="noteMark" defaultValue={noteMark} options={noteMarkList} updateOnChange={updateField} className="-x-small" />
            <div className="form-field">
                <AsyncTypeahead
                    name="nutrient"
                    defaultValue={nutrient}
                    creatable={true}
                    provider="/picklists/nutrition/"
                    updateOnChange={updateField}
                />
            </div>
            <Select name="minMax" options={minMaxList} value={minMax} className="-small" updateOnChange={updateField} />
            {measurementItems}
            <button className="button -primary -small -margin" onClick={removeItem}>
                <FontAwesomeIcon icon={faTrash} />
            </button>
        </div>
    );
};

export default AnalysisItem;
